var _defs, _path, _path2, _g, _path3, _g2, _path4, _g3, _g4, _path5, _g5, _g6, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "09c994620e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 136 71.226562 L 239 71.226562 L 239 129 L 136 129 Z M 136 71.226562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4df424fb3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 248.359375 118.117188 L 309.136719 118.117188 L 309.136719 189 L 248.359375 189 Z M 248.359375 118.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b215a61591"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66.15625 118 L 127 118 L 127 189 L 66.15625 189 Z M 66.15625 118 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9ca4600880"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66.15625 196 L 127 196 L 127 268 L 66.15625 268 Z M 66.15625 196 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dba66c787b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 248.359375 196.480469 L 309.136719 196.480469 L 309.136719 267.597656 L 248.359375 267.597656 Z M 248.359375 196.480469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "882a2b8413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 136.792969 257 L 239 257 L 239 314.113281 L 136.792969 314.113281 Z M 136.792969 257 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066cc",
    d: "M 374.957031 187.457031 C 374.957031 291.0625 291.035156 375 187.5 375 C 129.492188 375 77.726562 348.675781 43.332031 307.308594 C 17.636719 276.429688 1.714844 237.144531 0.207031 194.253906 C 0.117188 192.027344 0.0429688 189.695312 0.0429688 187.457031 C 0.0429688 83.933594 83.964844 0 187.5 0 C 208.785156 0 229.1875 3.515625 248.230469 10.078125 C 287.753906 23.597656 321.269531 49.921875 343.914062 84.167969 C 363.515625 113.773438 374.957031 149.296875 374.957031 187.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 137.269531 102.179688 C 143.238281 90.867188 150.339844 81.589844 158.261719 74.933594 C 151.234375 76.671875 144.449219 79.023438 137.96875 81.921875 C 137.167969 82.28125 136.375 82.648438 135.585938 83.019531 C 120.886719 89.988281 107.808594 99.816406 97.078125 111.777344 C 107.359375 115.703125 117.964844 118.984375 128.851562 121.566406 C 131.320312 114.59375 134.144531 108.101562 137.269531 102.179688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09c994620e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 238.488281 123.324219 C 236.234375 117.082031 233.679688 111.261719 230.871094 105.9375 C 219.597656 84.578125 204.296875 71.367188 187.648438 71.367188 C 170.996094 71.367188 155.695312 84.578125 144.421875 105.9375 C 141.613281 111.261719 139.0625 117.082031 136.804688 123.324219 C 137.46875 123.457031 138.132812 123.589844 138.800781 123.722656 C 154.609375 126.8125 170.9375 128.429688 187.648438 128.429688 C 204.355469 128.429688 220.683594 126.8125 236.492188 123.722656 C 237.160156 123.589844 237.824219 123.457031 238.488281 123.324219 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 278.21875 111.777344 C 267.488281 99.816406 254.40625 89.988281 239.707031 83.019531 C 239.03125 82.703125 238.351562 82.386719 237.671875 82.078125 C 231.085938 79.109375 224.183594 76.707031 217.035156 74.933594 C 224.953125 81.589844 232.054688 90.867188 238.023438 102.179688 C 241.148438 108.101562 243.972656 114.59375 246.441406 121.566406 C 257.328125 118.984375 267.933594 115.703125 278.21875 111.777344 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4df424fb3f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 309.136719 188.695312 C 308.269531 162.203125 298.902344 137.859375 283.671875 118.292969 C 272.417969 122.730469 260.832031 126.40625 248.964844 129.265625 C 254.308594 146.90625 257.496094 167.144531 257.851562 188.695312 L 309.136719 188.695312 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 249.746094 188.695312 C 249.390625 167.695312 246.273438 148.050781 241.058594 131.039062 C 240.058594 131.246094 239.050781 131.449219 238.046875 131.644531 C 221.703125 134.839844 204.855469 136.511719 187.648438 136.511719 C 170.4375 136.511719 153.589844 134.839844 137.25 131.644531 C 136.242188 131.449219 135.238281 131.246094 134.234375 131.039062 C 129.023438 148.050781 125.902344 167.695312 125.546875 188.695312 L 249.746094 188.695312 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b215a61591)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 117.441406 188.695312 C 117.796875 167.144531 120.984375 146.90625 126.328125 129.265625 C 114.460938 126.40625 102.875 122.730469 91.621094 118.292969 C 76.390625 137.859375 67.023438 162.203125 66.15625 188.695312 L 117.441406 188.695312 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ca4600880)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 126.328125 256.214844 C 120.984375 238.574219 117.796875 218.335938 117.441406 196.78125 L 66.15625 196.78125 C 67.023438 223.277344 76.390625 247.621094 91.621094 267.183594 C 102.875 262.75 114.460938 259.070312 126.328125 256.214844 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 241.058594 254.441406 C 246.273438 237.425781 249.390625 217.785156 249.746094 196.78125 L 125.546875 196.78125 C 125.902344 217.785156 129.023438 237.425781 134.234375 254.441406 C 135.238281 254.230469 136.242188 254.027344 137.25 253.832031 C 153.589844 250.636719 170.4375 248.964844 187.648438 248.964844 C 204.855469 248.964844 221.703125 250.636719 238.046875 253.832031 C 239.050781 254.027344 240.058594 254.230469 241.058594 254.441406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dba66c787b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 283.671875 267.183594 C 298.902344 247.621094 308.269531 223.277344 309.136719 196.78125 L 257.851562 196.78125 C 257.496094 218.335938 254.308594 238.574219 248.964844 256.214844 C 260.832031 259.070312 272.417969 262.75 283.671875 267.183594 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#882a2b8413)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 230.871094 279.542969 C 233.679688 274.21875 236.234375 268.398438 238.488281 262.15625 C 237.824219 262.019531 237.160156 261.886719 236.492188 261.757812 C 220.683594 258.667969 204.355469 257.046875 187.648438 257.046875 C 170.9375 257.046875 154.609375 258.667969 138.800781 261.757812 C 138.132812 261.886719 137.46875 262.019531 136.804688 262.15625 C 139.0625 268.398438 141.613281 274.21875 144.421875 279.542969 C 155.695312 300.902344 170.996094 314.113281 187.648438 314.113281 C 204.296875 314.113281 219.597656 300.902344 230.871094 279.542969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 158.261719 310.546875 C 150.339844 303.886719 143.238281 294.609375 137.269531 283.300781 C 134.144531 277.375 131.320312 270.882812 128.851562 263.910156 C 117.964844 266.496094 107.359375 269.777344 97.078125 273.699219 C 107.808594 285.664062 120.886719 295.488281 135.585938 302.457031 C 136.375 302.832031 137.167969 303.195312 137.96875 303.554688 C 144.449219 306.457031 151.234375 308.804688 158.261719 310.546875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 239.707031 302.457031 C 254.40625 295.488281 267.488281 285.664062 278.21875 273.699219 C 267.933594 269.777344 257.328125 266.496094 246.441406 263.910156 C 243.972656 270.882812 241.148438 277.375 238.023438 283.300781 C 232.054688 294.609375 224.953125 303.886719 217.035156 310.546875 C 224.183594 308.773438 231.085938 306.371094 237.671875 303.398438 C 238.351562 303.089844 239.03125 302.777344 239.707031 302.457031 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFull);
export default __webpack_public_path__ + "static/media/web_full.04443f4519d1e0357adba9336b45bd71.svg";
export { ForwardRef as ReactComponent };